import { Api } from '@/api'
import { get } from 'lodash'

const state = {
  userId: '',
  userName: '',
  userInfo: {},
  userInfos: {},
  userPermission: [],
  userBtnPermissionTree: [],
  userScrollTop: [],
  provinceData: [], // 省数据
  cityData: [], // 市数据
  areaData: [], // 省市区数据
  deptData: [], // 部门数据
  userData: [], // 用户数据
  roleData: [], // 角色数据
  dictionaryList: [], // 字典数据（非树结构）
  groupList: [], // 面试抄送人员数据，用于回显匹配
  accountPermission: {
    dataPermission: false,
    isCorrelation: false
  }, // 简历详情,账号是不是有按钮权限 (dataPermission:数据权限; isCorrelation:3类角色)
  zxtPermission: true, // 企业是否开通臻学堂
  zrcPermission: true, // 企业是否开通臻人才
  userDataPermission: {
    resume : {
      delete: {
        dataPermissionType: '',
        userIds: []
      },
      edit: {
        dataPermissionType: '',
        userIds: []
      },
    },
    job : {
      delete: {
        dataPermissionType: '',
        userIds: []
      },
      edit: {
        dataPermissionType: '',
        userIds: []
      },
    }
  },
  settingDataOn: 0, // 水印开关
  userRole: [], // 角色权限
  carrierMode:'企微',
  userRoleList: [] // 用户角色列表
}

const mutations = {
  userId: (state, data) => {
    state.userId = data
  },
  userName: (state, data) => {
    state.userName = data
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfos = userInfo
    state.carrierMode = userInfo.appSource === 4 ? '飞书' : '企微';
  },
  setUserPermission: (state, permission) => {
    state.userPermission = permission
  },
  userBtnPermissionTree: (state, permission) => {
    state.userBtnPermissionTree = permission
  },
  userScrollTop: (state, data) => {
    state.userScrollTop = data
  },
  // 省市区
  SET_AREA: (state, data) => {
    console.log('data===', data)
    state.areaData = data
  },
  // 省市
  SET_CITY: (state, data) => {
    console.log('data===', data)
    state.cityData = data
  },
  // 省市
  SET_PROVINCE: (state, data) => {
    console.log('data===', data)
    state.provinceData = data
  },
  // 部门
  SET_DEPT: (state, data) => {
    state.deptData = data
  },
  // 用户
  SET_USER: (state, data) => {
    state.userData = data
  },
  // 角色
  SET_ROLE: (state, data) => {
    state.roleData = data
  },
  // 字典（非树结构）
  SET_DICTIONARY: (state, data) => {
    state.dictionaryList = data
  },
  // 企业是否开通臻学堂
  SET_ZXTPERMISSION: (state, data) => {
    state.zxtPermission = data
  },
  // 企业是否开通臻人才
  SET_ZRCPERMISSION: (state, data) => {
    state.zrcPermission = data
  },
  SET_GROUPLIST: (state, data) => {
    state.groupList = data
  },
  SET_ACCOUNT_PERMISSION: (state, data) => {
    state.accountPermission = data
  },
  SET_USERDATAPERMISSION: (state, data) => {
    state.userDataPermission[data.type][data.operate] = data.data
    console.log('state.userDataPermission', state.userDataPermission);
  },
  SET_settingDataOn: (state, data) => {
    state.settingDataOn = data
  },
  SET_USER_ROLE: (state, data) => {
    state.userRole = data
  },
  SET_USER_ROLE_LIST: (state, data) => {
    state.userRoleList = data
  },
}

const actions = {
  getUserInfos: function({ commit }) {
    return new Promise((resolve, reject) => {
      return Api.getUserInfos({}).then(res => {
        if (res.code === 200) {
          commit('SET_USERINFO', res.data || {})
          if (res.data?.loginUserId) {
            // 获取是否超管: accountType主账号 0主账号 1子账号; isAdmin系统管理员 0否 1是
            Api.getUserDetail({ userId: res.data?.loginUserId }).then(info => {
              if (info.code === '0') {
                const userData = res.data
                if(info.data){
                  for (const key in info.data) {
                    if(!userData[key]){
                      userData[key] = info.data[key]
                    }
                  }
                }
                commit('SET_USERINFO', { ...userData, isSuperAdmin: (info.data?.accountType === 0 || info.data?.isAdmin === 1) })
              }
            })
          }
        } else {
          commit('SET_USERINFO', {})
        }
        resolve(res)
      }).catch(() => {
        resolve({})
      })
    })
  },
  getAllDictionary: function({ commit }) {
    return new Promise((resolve, reject) => {
      Api.getAllDictionary({}).then(res => {
        if (res.code === '0') {
          commit('SET_DICTIONARY', res.data || [])
          resolve(res.data)
        } else {
          commit('SET_DICTIONARY', [])
          reject(res)
        }
      }).catch(err => { reject(err) })
    })
  },
  zxtPermission: function({ commit }, accountId) {
    return new Promise((resolve, reject) => {
      Api.zxtPermission({ accountId }).then(res => {
        if (res.code === 200) {
          commit('SET_ZXTPERMISSION', res.data)
          resolve(res.data)
        } else {
          commit('SET_ZXTPERMISSION', false)
          reject(res)
        }
      }).catch(err => { reject(err); commit('SET_ZXTPERMISSION', false) })
    })
  },
  zrcPermission: function({ commit }, accountId) {
    return new Promise((resolve, reject) => {
      Api.zrcPermission({ accountId }).then(res => {
        if (res.code === 200) {
          commit('SET_ZRCPERMISSION', res.data)
          resolve(res.data)
        } else {
          commit('SET_ZRCPERMISSION', false)
          reject(res)
        }
      }).catch(err => { reject(err); commit('SET_ZRCPERMISSION', false) })
    })
  },
  getUserDataPermission: function({ commit }, getData) {
    return new Promise((resolve, reject) => {
       // 1584905060654116866,简历  1584905060654116875,职位
      let objectId = ''
      if(getData.type === 'resume'){
        objectId = '1584905060654116866'
      }else if(getData.type === 'job'){
        objectId = '1584905060654116875'
      }else{
        return false
      }
      let operate = ''
      if(getData.permissionType === 1){
        operate = 'edit'
      }else if(getData.permissionType === 2){
        operate = 'delete'
      }else{
        return false
      }
      const params = {
        objectId,  // 1584905060654116866,简历  1584905060654116875,职位
        permissionType: getData.permissionType, // 0 查看权限 1编辑权限 2删除权限
        tenantId: state.userInfos.accountId,
        userId: state.userInfos.loginUserId
      }
      Api.getUserDataPermission(params).then(res => {
        if (res.code === '0') {
          commit('SET_USERDATAPERMISSION', {
            type: getData.type,
            operate,
            data:res.data
          })
          resolve(res.data)
        }
      }).catch(err => { reject(err); })
    })
  },
  getAllPermissions: function({ commit }) {
    const urlParams = new URLSearchParams(window.location.href)
    const isWebsiteIframe = !(window.self === window.top) && urlParams.get('source') === 'website'
    if (isWebsiteIframe) return
    return Api.getAllPermission({}).then(res => {
      if (res.code === 200) {
        if (res.data.source === 2) {
          let role = false
          if(res.data && res.data.data.length>0){
            const permissionCodes = res.data.data.map(item => item.permissionCode)
            if(permissionCodes.includes('zzp_consultant')){ // 实施顾问可以进
              role = true
            }
          }
          if(!role){
            Api.loginOut().then(res => {
              if (res.code === 200) {
                console.log('out')
                location.reload()
              }
            })
          }
        }
      }
    })
  },
  getUserPermission: function({ commit }) {
    return new Promise((resolve, reject) => {
      Api.getUserInfo().then(res => {
        if (res) {
          const userInfo = res
          const userPermission = get(res, 'subChannelList[0].functionPermissionList') || []
          const userBtnPermissionTree = get(res, 'subChannelList[0].treeFunctionPermissionList') || []
          commit('userId', res.userId)
          commit('userName', res.userName || res.fullName)
          commit('userInfo', userInfo)
          commit('setUserPermission', userPermission)
          commit('userBtnPermissionTree', userBtnPermissionTree)
          sessionStorage.setItem('userPermission', JSON.stringify(userPermission))
          sessionStorage.setItem('userId', res.userId)
          sessionStorage.setItem('userName', res.userName || res.fullName)
          resolve(userPermission)
        }
      }).catch(err => { reject(err) })
    })
  },
  // 省市区查询
  listAreaData: function({ commit }, vo) {
    return Api.getGeologyTree(vo).then(res => {
      if (res && res.code === '0') {
        const param = JSON.parse(res.__responseConfig__?.data || {})
        const levelLength = param.levels && param.levels.length
        // console.log(levelLength, param, 'eq======levelLength')
        // 省、省市和省市区区分，同时存在两个类型有冲突
        if (levelLength && levelLength === 1) {
          commit('SET_PROVINCE', res.data || [])
        }
        if (levelLength && levelLength === 2) {
          commit('SET_CITY', res.data || [])
          // console.log(res.data, 'eq======SET_CITY')
        }
        if (levelLength && levelLength === 3 || !levelLength) {
          commit('SET_AREA', res.data || [])
        }
      } else {
        commit('SET_CITY', res.data || [])
        commit('SET_AREA', [])
      }
    })
  },
  // 部门查询
  getAllDepartmentTree: function({ commit }) {
    return Api.getAllDepartmentTree({}).then(res => {
      if (res && res.code === '0') {
        commit('SET_DEPT', res.data || [])
      } else {
        commit('SET_DEPT', [])
      }
    })
  },
  // 用户查询
  getAllUserDepartmentTree: function({ commit }, vo) {
    console.log(vo, 'vovovoovvvoov')
    return Api.getAllUserDepartmentTree(vo).then(res => {
      if (res && res.code === '0') {
        commit('SET_USER', res.data || [])
      } else {
        commit('SET_USER', [])
      }
    })
  },
  // 角色查询
  listRole: function({ commit }, vo) {
    return Api.listRole(vo).then(res => {
      if (res && res.code === '0') {
        commit('SET_ROLE', res.data || [])
      } else {
        commit('SET_ROLE', [])
      }
    })
  },
  queryUserRole: function({ commit }) {
    return new Promise((resolve, reject) => {
      return Api.queryUserRole({}).then(res => {
        if (res && res.code === '0') {
          // 1自定义角色 10管理员 11普通用户 12招聘HR 13面试官 14运营平台管理员 15业务经理身份 16用人部门主管 17校招管理员 18校招专员
          commit('SET_USER_ROLE', res.data || [])
        } else {
          commit('SET_USER_ROLE', [])
        }
        resolve(res)
      }).catch(() => {
        resolve(new Error('获取用户角色失败'))
      })
    })
  },
  queryUserRoleList: function({ commit }) {
    return new Promise((resolve, reject) => {
      return Api.queryUserRoleList().then(res => {
        if (res && res.code === '0') {
          commit('SET_USER_ROLE_LIST', res.data || [])
          resolve(res.data || [])
        } else {
          commit('SET_USER_ROLE_LIST', [])
          resolve([])
        }
      }).catch((err) => {
        commit('SET_USER_ROLE_LIST', [])
        reject(err)
      })
    })
  },
}

const getters = {
  showAiInterviewConsultant: (state) => {
    const targetIds = ['1714588526566637570', '2037430683373481985', '1714588526566637570']
    if (!state.userRoleList || !state.userRoleList.length) return false
    return state.userRoleList.some(role =>
      targetIds.includes(String(role.id)) && role.choose === true
    )
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
